import type { ListBuilderList } from '../../../types';
import { createTripColumnsWithDate } from '../columns';

/**
 * Completed Routes list configuration
 * Shows completed routes
 */
export const completedTripsList: ListBuilderList = {
	id: 'completed-trips',
	name: 'Completed',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		routeStatus: {
			defaultValue: [{ id: 'completed', label: 'Completed' }],
		},
	},
	columns: createTripColumnsWithDate(),
	defaultSortId: 'date-desc',
	sortOrder: 4,
};
